export const MESSAGES = {
  CREATE_PASSWORD_REQUIRED_MESSAGE: "Create Password is required",
  UNIQUE_USERID_MESSAGE: "User ID entered in use.Please try another",
  PAGE_LOADER_MESSAGE: "Please give us a moment while we look you up.",
  TERMS_AND_CONDITION_VALIDATION_MESSAGE: "Please acknowledge to continue",
  OKTA_COMMON_PASSWORD_ERROR: "Password is too common, please provide a new password.",
  INVALID_PHONE_NUMBER_MESSAGE: "Enter valid phone number.",
  PASSWORD_CONTAIN_USERNAME_MESSAGE: "Your password can't include any part of your username.",
};
